<template>
  <a-modal
    :title="$t('选择商品')"
    :visible="visible"
    :footer="null"
    :width="900"
    @cancel="handleCancel"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t('商品编号')">
              <a-input v-model="queryParam.id" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('商品编号')" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t('商品名称')">
              <a-input v-model="queryParam.goodsName" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('商品名称')" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
            <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table
      :scroll="{ x: '100%' }"
      :loading="loading"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <template slot="picture" slot-scope="text, record">
        <img v-if="record.picture" :src="record.picture" style="width:40px;height:40px;" alt="none" />
      </template>
      <template slot="goodsType" slot-scope="text, record">
        <custom-dict-tag :options="customDict.GoodsTypeEnum" :value="record.goodsType" />
      </template>
      <template slot="status" slot-scope="text, record">
        <custom-dict-tag :options="customDict.GoodsOnOffEnum" :value="record.status" />
      </template>
    </a-table>

    <div style="text-align: right; padding: 16px;">
      <a-button @click="handleCancel">{{ $t('取消') }}</a-button>
      <a-button type="primary" :disabled="!selectedRowKeys.length" @click="handleConfirm">{{ $t('确认') }}</a-button>
    </div>
  </a-modal>
</template>

<script>
import { pageGoods } from '@/api/goods/goods'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'

export default {
  name: 'SelectGoodsModal',
  components: {
    CustomDictTag
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      loading: false,
      selectedRowKeys: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      queryParam: {
        id: undefined,
        goodsName: undefined,
        isGift: 0,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商品编号'),
          dataIndex: 'id',
          width: 120
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          width: 200
        },
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          width: '80px',
          scopedSlots: { customRender: 'picture' }
        },
        {
          title: this.$t('商品类型'),
          dataIndex: 'goodsType',
          width: '120px',
          scopedSlots: { customRender: 'goodsType' },
          align: 'center'
        },
        {
          title: this.$t('商品状态'),
          dataIndex: 'status',
          width: '100px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('商品售价'),
          dataIndex: 'price',
          width: '100px'
        },
        {
          title: this.$t('库存'),
          dataIndex: 'stock',
          width: '80px'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    visible(val) {
      if (val) {
        this.getList()
      }
    }
  },
  methods: {
    getList() {
      this.loading = true
      pageGoods(this.queryParam).then(response => {
        this.list = response.data.records
        this.pagination.total = response.data.total
        this.loading = false
      })
    },

    handleQuery() {
      this.queryParam.pageNum = 1
      this.pagination.current = 1
      this.getList()
    },

    resetQuery() {
      this.queryParam = {
        id: undefined,
        goodsName: undefined,
        isGift: 0,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    handleCancel() {
      this.$emit('cancel')
    },

    handleConfirm() {
      const selectedItems = this.list.filter(item => this.selectedRowKeys.includes(item.id))
      this.$emit('confirm', selectedItems)
    },

    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.queryParam.pageNum = current
      this.getList()
    },

    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>